<template>
    <div>
        <page-title>{{ $t('menu.residential_canteens') }}</page-title>
        <residential-canteen-table
            ref="table"
            @company-filter="companyFilter = $event"
        >
            <template v-slot:actions>
                <create-button
                    :route-name="routeType.RESIDENTIAL_CANTEENS_CREATE"
                ></create-button>
            </template>
        </residential-canteen-table>
    </div>
</template>

<script>
import PageTitle from '@/components/layout/components/pageTitle'
import routeType from '@/router/routeType'
import ResidentialCanteenTable from '@/components/pages/residentialCanteens/Table'
import CreateButton from '@/components/form/Actions/CreateButton'
import AuthMixin from '@/components/mixins/AuthMixin'

export default {
    components: {
        PageTitle,
        ResidentialCanteenTable,
        CreateButton,
    },
    mixins: [AuthMixin],
    data() {
        return {
            routeType,
            companyFilter: null,
        }
    },
    computed: {
        company() {
            return this.isSuperAdmin ? this.companyFilter : this.activeCompany
        },
        companySelect() {
            return this.isSuperAdmin
        },
    },
}
</script>
